import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"

type SliderProps = React.ComponentProps<typeof SliderPrimitive.Root> & {
 thumbLabels?: readonly string[]
 thumbValueTexts?: readonly string[]
}

function Slider({
  ref,
  className,
  thumbLabels,
  thumbValueTexts,
  ...props
}: SliderProps) {
  const thumbCount = (props.value ?? props.defaultValue ?? [0]).length;
  return (
    <SliderPrimitive.Root
      ref={ref}
      className={cn(
        "relative flex w-full touch-none select-none items-center",
        className,
      )}
      {...props}
    >
      <SliderPrimitive.Track className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-action-tint">
        <SliderPrimitive.Range className="absolute h-full bg-action-fill" />
      </SliderPrimitive.Track>
      {Array.from({ length: thumbCount }, (_thumb, index) => (
        <SliderPrimitive.Thumb
          key={index}
          aria-label={thumbLabels?.[index]}
          aria-valuetext={thumbValueTexts?.[index]}
          className="block h-4 w-4 rounded-full border border-primary/50 bg-card transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50"
        />
      ))}
    </SliderPrimitive.Root>
  );
}

export { Slider }
